import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const usePackages = () => {
    
    const getPackages = useCallback(async (data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/packages/find/openLocker` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
           
        });
        
        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload);
        else return ([]);
    }, [])

    const createPackage = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/packages/register/individual`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify(data),
                signal 
        });
        
        const result = await response.json();
        
        return (result);
    }, [])
 
    const getEstatusAlerted = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/packages/estatus/alerted`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal
        });

        const result = await response.json();
         
        return (result);
    }, [])
  
    const  getPackagesAlerted = useCallback(async (dataToSend) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/packages/find/tracking/alerted`, {
            method: 'POST',
            connection: 'keep-alive',
            accept: 'application/json',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(dataToSend)
          
        });

        const result = await response.json();
        
        return (result);
    }, [])

    const deleteAlerted = useCallback(async (data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/packages/cancel/alerted`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();
        
        return (result);
    }, []);

    const syncPackageToLocker = useCallback(async (data) => {
        const response = await fetch(`${getClientDomain()}/packages/golocker/sync/${data.reservationId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();
        if (result) return (result);
        else return ([]);
        }, []);

        const getPackagesReturned = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/returnedXMonth/user
            `, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                    },
                    body: JSON.stringify(data)
                    });
                    const result = await response.json();
                    if (result) return (result);
                    else return ([]);
                    }
                    , []);

        const getStatsLastYear = useCallback(async (signal, data) => {
                        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/lastYear`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': `Bearer ${getToken()}`
                                },
                                signal,
                                body: JSON.stringify(data)
                                });
                                const result = await response.json();
                                
                                if (result.payload) return (result);
                                else return ({payload: []});
                                }
                                , []);

        const getStatsXMonth = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/xmonth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                    },
                    signal,
                    body: JSON.stringify(data)
                    });
                    const result = await response.json();
                    
                    if (result.payload) return (result);
                    else return ({payload: []});
                    }
                    , []);
        
        
          const getPickupMonthByClient = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain(2)}/dashboard/packages/stats/pickup-month-client`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                    },
                    signal,
                    body: JSON.stringify(data)
                    });
                    const result = await response.json().catch(() => null);

                    // El 404 del endpoint significa "el rango no tiene retiros"; cualquier otro
                    // fallo es un error, y la vista necesita distinguirlos para no pintar
                    // "no hay datos" encima de un 400 o un 500.
                    if (response.ok) return ({ ok: true, payload: result?.payload ?? [] });
                    if (response.status === 404) return ({ ok: true, payload: [] });
                    return ({ ok: false, payload: [], message: result?.message ?? `HTTP_${response.status}` });
                    }
                    , []);

            const getPickupMonthByLocker = useCallback(async (signal, data) => {
                const response = await fetch(`${getClientDomain(2)}/dashboard/packages/stats/pickup-month-locker`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                        },
                        signal,
                        body: JSON.stringify(data)
                        });
                        const result = await response.json();
                        if (result.payload) return (result?.payload);
                        else return ({payload: []});
                        }
                        , []);

            const getPickupYear = useCallback(async (signal, data) => {
                const response = await fetch(`${getClientDomain(2)}/dashboard/packages/stats/pickup-year`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                        },
                        signal,
                        body: JSON.stringify(data)
                        });
                        const result = await response.json();
                        if (result.payload) return (result?.payload);
                        else return ({payload: []});
                        }
                        , []);

            const getPickupByDay = useCallback(async (signal, data) => {
                const response = await fetch(`${getClientDomain(2)}/dashboard/packages/stats/pickup-day`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                        },
                        signal,
                        body: JSON.stringify(data)
                        });
                        const result = await response.json();
                        if (result.payload) return (result?.payload);
                        else return ({payload: []});
                        }
                        , []);

            const getStatsOccupationTotal = useCallback(async (signal, data) => {
                const response = await fetch(`${getClientDomain(2)}/dashboard/packages/stats/occupation-total`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                        },
                        signal,
                        body: JSON.stringify(data)
                        });
                        const result = await response.json();
                        if (result.payload) return (result?.payload);
                        else return ({payload: []});
                        }
                        , []);

            const saveTrackingViewPin = useCallback(async (signal, data) => {
                const response = await fetch(`${getClientDomain(2)}/dashboard/packages/tracking/view-pin`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                        },
                        signal,
                        body: JSON.stringify(data)
                        });
                let result = {};
                try {
                    result = await response.json();
                } catch {
                    result = {};
                }
                const code = result.code != null ? result.code : response.status;
                const success = response.status === 200 && (result.code == null || result.code === 200);
                if (!success) {
                    return {
                        ok: false,
                        status: response.status,
                        code,
                        message: result.message,
                    };
                }
                return { ok: true, ...result };
                        }, []);

    return {getPackages, createPackage, getEstatusAlerted, getPackagesAlerted, deleteAlerted, syncPackageToLocker, getPackagesReturned, getStatsLastYear, getStatsXMonth, getPickupMonthByClient, getPickupMonthByLocker, getPickupYear, getPickupByDay, getStatsOccupationTotal, saveTrackingViewPin};
}